import { UserInfo } from '../../src/types';

export const mockUserInfo = ({
  locale = 'he-il',
  timezone = 'America/Mexico_City',
  contactId = 'some-contact-id',
}: Partial<UserInfo> = {}): UserInfo => {
  return {
    locale,
    timezone,
    contactId,
  };
};
